import CustomButton from 'components/buttons/CustomButton'
import React, { useEffect, useState } from 'react'
import FontAwesome from 'react-fontawesome'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { fetchLocationsSuccess } from 'store/actions/resourceActions'
import I18n from '../../resources/i18n/I18n'
import LocationApi from '../../services/locationApi'
import LabelEditionTree from './LabelEditionTree'

const LocationEdition = () => {
  const [error, setError] = useState(null)
  const dispatch = useDispatch()
  const history = useHistory()

  const locations = useSelector((state) => state.resourceReducer.locations)

  useEffect(() => {
    if (locations.length === 0) {
      getLocations()
    }
  }, [locations.length, dispatch])

  const goBack = () => {
    history.push('/configuration')
  }

  const getLocations = () => {
    LocationApi.getLocationList().then((response) => dispatch(fetchLocationsSuccess(response)))
  }

  const deleteLocation = (location) => {
    setError(null)
    LocationApi.deleteLocationSubtype(location.id)
      .then(getLocations)
      .catch(() => setError(I18n.t('ErrorDelete')))
  }

  const editLocation = (location) => {
    LocationApi.editLocationSubtype(location).then(getLocations)
  }

  const createLocation = (item) => {
    LocationApi.addLocationSubtype(item.idParent, { label: item.label }).then(getLocations)
  }

  return (
    <div className="container-fluid">
      <LabelEditionTree items={locations} deleteLabel={deleteLocation} editLabel={editLocation} createLabel={createLocation} error={error} />
      <div className="row justify-content-center p-4">
        <CustomButton onClick={goBack} icon={<FontAwesome name="arrow-left" />} small secondary />
      </div>
    </div>
  )
}

export default LocationEdition
